import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import MainContentWrapper from './MainContentWrapper';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop'; // 추가
import { CssBaseline } from '@mui/material';

function App() {
  return (
    <Router>
      <CssBaseline />
      <ScrollToTop /> {/* 추가 */}
      <NavigationBar />
      <MainContentWrapper />
      <Footer /> {/* Footer 컴포넌트 추가 */}
    </Router>
  );
}

export default App;
